import { AppLayout } from "@/components/AppLayout";
import { GenerationHistory } from "@/components/GenerationHistory";
import { useState } from "react";
import { ImagePreview } from "@/components/ImagePreview";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useSubscription } from "@/hooks/useSubscription";
import { Clock, AlertTriangle, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { Generation } from "@/hooks/useGenerations";

const History = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const { subscription } = useSubscription();
  const isFreePlan = !subscription || subscription.plan === "free";
  const navigate = useNavigate();

  const handleRemix = (gen: Generation) => {
    navigate("/remix", { 
      state: { 
        imageUrl: gen.image_url, 
        prompt: gen.prompt 
      } 
    });
  };

  return (
    <AppLayout title="Historique">
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-foreground mb-2">Historique des générations</h1>
          <p className="text-muted-foreground">Retrouvez toutes vos créations passées</p>
        </div>

        {/* Free plan warning */}
        {isFreePlan && (
          <div className="mb-6 p-4 bg-highlight/10 border border-highlight/30 rounded-2xl">
            <div className="flex items-start gap-3">
              <div className="p-2 bg-highlight/20 rounded-xl">
                <Clock className="w-5 h-5 text-highlight" />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <AlertTriangle className="w-4 h-4 text-highlight" />
                  <h3 className="font-semibold text-foreground">Plan Free - Conservation limitée</h3>
                </div>
                <p className="text-sm text-muted-foreground mb-3">
                  Avec le plan gratuit, vos images sont automatiquement supprimées après <strong>24 heures</strong>. 
                  Passez à un plan payant pour conserver vos créations indéfiniment et accéder à toutes les fonctionnalités.
                </p>
                <Link to="/pricing">
                  <Button size="sm" className="bg-gradient-floop hover:opacity-90 text-white rounded-full">
                    <Crown className="w-4 h-4 mr-2" />
                    Passer à un plan payant
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        )}
        
        <GenerationHistory 
          onSelect={(gen) => setSelectedImage(gen.image_url)}
          onRemix={handleRemix}
        />

        <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
          <DialogContent className="max-w-4xl bg-card border-border p-0">
            <div className="p-6">
              <ImagePreview 
                imageUrls={selectedImage ? [selectedImage] : []} 
                isLoading={false} 
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </AppLayout>
  );
};

export default History;
